import { Component , Input } from '@angular/core';
import { INavigationModel } from './sui.navigation.model';

@Component({
  selector: 'sui-nav',
  template: require('./sui.navigation.component.html')
})
export class NavigationComponent {
  showSmallMenu: boolean = false;
  @Input() nav: INavigationModel;

  onBarsClicked() {
    this.showSmallMenu = !this.showSmallMenu;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sui/sui.navigation/sui.navigation.component.ts